import { EXPERIMENTS } from 'Services/optimizely/optimizely.consts';

import { useOptimizelyDecision } from '../useOptimizelyDecision';

export const useAiCompanionExperimentation = () => {
	const { isEnabled } = useOptimizelyDecision({ experimentId: EXPERIMENTS.ENABLE_AI_COMPANION });
	return isEnabled;
};
